import { APP_VERSION } from '@/shared/config/app-version';
import { replica } from '@/shared/sync/replica';

/** Download everything this device holds (deleted records excluded) as one JSON file. */
export async function exportData(): Promise<void> {
  const views = await replica.listAll();
  const out: Record<string, unknown> = { exported_at: new Date().toISOString(), version: APP_VERSION };
  for (const view of views) {
    if (view.deleted_at) continue;
    const list = (out[view.collection] as unknown[] | undefined) ?? [];
    list.push({ id: view.id, ...view.data, created_at: view.created_at, updated_at: view.updated_at });
    out[view.collection] = list;
  }
  const url = URL.createObjectURL(new Blob([JSON.stringify(out, null, 2)], { type: 'application/json' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `survival-kit-${new Date().toISOString().slice(0, 10)}.json`;
  link.click();
  URL.revokeObjectURL(url);
}
